/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {genericGetUserSessions} from '../api'

export const useMutationGenericGetUserSessions = createReactQueryMutationHook('genericGetUserSessions', genericGetUserSessions)
